import React, {FC} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    LinearProgress,
    TextField,
    Typography
} from "@material-ui/core";
import {FeOrder} from "../redux/types";
import {OrderPreviewCard} from "./OrderPreviewCard";
import {useEditorLocation} from "../../../editor/editor.hook";
import {useHistory, useRouteMatch} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {useAppDispatch} from "../../../redux/redux.hook";
import {cancelOrderThunk} from "../redux/orders.thunk";

const useStyles = makeStyles((theme) => ({
    cancelOrderButton: {
        /*  backgroundColor: theme.palette.error.main,*/
        color: theme.palette.error.main
    }
}));

interface CancelOrderDialogProps {
    order: FeOrder;
    type: "worker" | "admin";
}

export const CancelOrderDialog: FC<CancelOrderDialogProps> = ({order, type}) => {
    const classes = useStyles();

    const dispatch = useAppDispatch();
    const {url} = useRouteMatch();
    const history = useHistory();
    const {mode, reference} = useEditorLocation();
    const dialogOpen = mode === "edit" && reference === "cancel-order";
    const closeDialog = () => {
        history.replace({pathname: url, search: undefined, hash: undefined});
        setReason("");
    };
    const [reason, setReason] = React.useState("");

    const [loading, setLoading] = React.useState(false);

    const handleCancelOrder = () => {
        setLoading(true);
        dispatch(cancelOrderThunk({id: order.id, reason, type}))
            .then(() => {
                setLoading(false);
                closeDialog();
                if(type === "worker") {
                    history.replace("/worker/schedule");
                }
            })
            .catch(() => {
            })
    }

    return (
        <Dialog open={dialogOpen} onClose={closeDialog}>
            <DialogTitle>
                <Typography
                    variant="inherit"
                    color="secondary"
                >
                    Termin absagen
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Willst du wirklich folgenden Termin absagen?
                </DialogContentText>
                <OrderPreviewCard order={order} showActions={false}/>
                <TextField
                    multiline
                    required
                    label={"Grund für Absage"}
                    onChange={e => setReason(e.target.value)}
                    fullWidth
                />
            </DialogContent>
            {
                loading ?
                    (<LinearProgress/>)
                    : (<DialogActions>
                        <Button onClick={closeDialog}>
                            Abbrechen
                        </Button>
                        <Button
                            disabled={reason === ""}
                            className={classes.cancelOrderButton}
                            onClick={handleCancelOrder}
                        >
                            Absagen
                        </Button>
                    </DialogActions>)}
        </Dialog>
    )
}
